/* eslint-disable no-undef */
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FEEDER_TYPES, FeederMenuType } from '../../types/menu';

declare let $: any;

@Component({
  selector: 'feeder-select',
  template: require('./feeder-select.component.html'),
})
export class FeederSelectComponent implements OnInit {
  items: any[] = [];
  selected_items: any[] = [];
  type: FeederMenuType;
  levels: number = -1;
  selection: any;
  selected: boolean = false;
  favorites: any;
  selected_favorite: string = '';

  formControlSelectFavorite = new FormControl();

  @Input() selectOptions: any;
  @Output() typeChanged = new EventEmitter<FeederMenuType>();
  @Output() selectedChanged = new EventEmitter<boolean>();
  @Output() selectedItemsChanged = new EventEmitter<any[]>();
  @Output() spotChanged = new EventEmitter<boolean>();

  ngOnInit() {
    this.loadFavorites();
    this.loadItems();
    this.formControlSelectFavorite.valueChanges.subscribe((val) => {
      this.loadFavorite(val);
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.addPreference(this.items);
  }

  addPreference(items: any) {
    localStorage.setItem(
      'feeder_level' +
        this.selected_items.length +
        '_' +
        this.type +
        '_' +
        this.selected_items[this.selected_items.length - 1],
      JSON.stringify(items)
    );
  }

  goBack(index: number) {
    this.selected = false;
    this.selected_items.length = index + 1;
    this.typeChanged.emit(this.type);
    this.selectedChanged.emit(this.selected);
    this.loadItems();
  }

  loadItems() {
    this.items = [];
    let parent: any;
    if (this.selected_items.length === 0) {
      parent = this.selectOptions;
    } else if (this.selected_items.length === 1) {
      if (this.type === FEEDER_TYPES.FUTURES || this.type === FEEDER_TYPES.LIVE_PRICES) {
        this.levels = 6;
      } else if (this.type === FEEDER_TYPES.FUNDAMENTAL_DATA) {
        this.levels = 4;
      } else if (this.type === FEEDER_TYPES.FORWARD_CURVE) {
        this.levels = 3;
      } else if (this.type === FEEDER_TYPES.ICIS_LONG_TERM_MODEL) {
        this.levels = 4;
      } else if (this.type === FEEDER_TYPES.SPOT) {
        this.levels = 4;
      }
      parent = this.selectOptions[this.selected_items[0]];
    } else if (this.selected_items.length >= 2) {
      this.selection = this.selectOptions[this.selected_items[0]];
      for (let i = 1; i < this.selected_items.length; i++) {
        this.selection = this.selection[this.selected_items[i]];
      }
      parent = this.selection;
    }
    let tempItems: any[] = Object.keys(parent).filter((key) => this.hasItems(parent[key]));
    this.items = this.sortByPreference(tempItems);
  }

  hasItems(value: any): boolean {
    if (Array.isArray(value)) {
      return !!value.length;
    }
    if (value !== null && typeof value === 'object') {
      return !!Object.keys(value).length;
    }
    return true;
  }

  sortByPreference(tempItems: any) {
    let preferences: any = localStorage.getItem(
      'feeder_level' +
        this.selected_items.length +
        '_' +
        (this.selected_items.length === 0 ? '' : this.type) +
        '_' +
        this.selected_items[this.selected_items.length - 1]
    );
    let items: any[] = [];
    if (preferences != null) {
      preferences = JSON.parse(preferences);
      preferences.forEach((item: any) => {
        if (tempItems.includes(item)) {
          tempItems.splice(tempItems.indexOf(item), 1);
          items.push(item);
        }
      });
    }
    if (this.selected_items.length !== 0) {
      tempItems.sort();
    }
    if (tempItems.length > 0) {
      tempItems.forEach((item: any) => {
        items.push(item);
      });
    }
    return items;
  }

  pick(index?: number) {
    if (index !== undefined) {
      if (this.selected_items.length === 0) {
        this.type = this.items[index];
        this.typeChanged.emit(this.type);
      }
      this.selected_items.push(this.items[index]);
      if (this.selected_items.length === this.levels) {
        this.selectedItemsChanged.emit(this.selected_items);
        this.selected = true;
        this.selectedChanged.emit(this.selected);
      } else {
        if (this.selected_items.length === 4) {
          this.spotChanged.emit(
            this.selected_items[3].toUpperCase() === 'IMBALANCE' ||
              this.selected_items[3].toUpperCase() === 'FORECAST' ||
              this.selected_items[3].toUpperCase() === 'DAY AHEAD' ||
              this.selected_items[3].toUpperCase() === 'INTRADAY' ||
              this.selected_items[3].toUpperCase() === 'SPOT'
          );
        }
        this.selectedItemsChanged.emit(this.selected_items);
        this.items = [];
        this.loadItems();
      }
    }
  }

  inFavorites() {
    if (this.favorites !== undefined && this.favorites !== null) {
      let keys = Object.keys(this.favorites);
      for (let i = 0; i < keys.length; i++) {
        let favorite = this.favorites[keys[i]];
        if (favorite.length !== this.selected_items.length) {
          continue;
        }
        let isFavorite = true;
        for (let j = 0; j < this.selected_items.length; j++) {
          if (favorite[j] !== this.selected_items[j]) {
            isFavorite = false;
            break;
          }
        }
        if (isFavorite) {
          return true;
        }
      }
    }
    return false;
  }

  favoriteList() {
    if (this.favorites !== undefined && this.favorites !== null) {
      return Object.keys(this.favorites);
    }
    return [];
  }

  loadFavorite(favorite?: string) {
    if (favorite === undefined || favorite === null) {
      favorite = this.selected_favorite;
    }
    this.goBack(-1);
    let favorites: any = localStorage.getItem('favorites');
    if (favorites !== null) {
      favorites = JSON.parse(favorites);
      for (let i = 0; i < favorites[favorite].length; i++) {
        let index = this.items.indexOf(favorites[favorite][i]);
        if (index !== -1) {
          this.pick(this.items.indexOf(favorites[favorite][i]));
        } else {
          break;
        }
      }
    }
  }

  loadFavorites() {
    let favorites: any = localStorage.getItem('favorites');
    if (favorites !== null) {
      this.favorites = JSON.parse(favorites);
      this.favorites = Object.keys(this.favorites)
        .sort()
        .reduce((obj: any, key: any) => {
          obj[key] = this.favorites[key];
          return obj;
        }, {});
    }
  }

  updateFavorites() {
    if (this.inFavorites()) {
      let favorites: any = localStorage.getItem('favorites');
      if (this.favorites !== null) {
        this.favorites = JSON.parse(favorites);
        let identifier = this.selected_items[0].split(' ')[0];
        for (let i = 1; i < this.selected_items.length; i++) {
          identifier += ' ' + this.selected_items[i];
        }
        delete this.favorites[identifier];
        if (Object.keys(this.favorites).length === 0) {
          localStorage.removeItem('favorites');
        } else {
          localStorage.setItem('favorites', JSON.stringify(this.favorites));
        }
      }
    } else {
      this.addToFavorites();
    }
    this.loadFavorites();
  }

  addToFavorites() {
    let favorites: any = localStorage.getItem('favorites');
    if (favorites === null) {
      favorites = {};
    } else {
      favorites = JSON.parse(favorites);
    }
    let identifier = this.selected_items[0].split(' ')[0];
    let selection: any[] = [];
    for (let i = 0; i < this.selected_items.length; i++) {
      if (i >= 1) {
        identifier += ' ' + this.selected_items[i];
      }
      selection.push(this.selected_items[i]);
    }
    favorites[identifier] = selection;
    localStorage.setItem('favorites', JSON.stringify(favorites));
    this.loadFavorites();
  }
}
